/* global globalThis */
import ReactGA from "react-ga4";
import {
  localStorageGetItem,
  localStorageRemoveItem,
} from "./Storage/storageUtils";

import AWSIcon from "../assets/images/aws.svg";
import AzureIcon from "../assets/images/azure.svg";
import NvidiaIcon from "../assets/images/nvidia.svg";
import MaleIcon1 from "../assets/images/digitalemployee/male1.mp4";
import MaleIcon2 from "../assets/images/digitalemployee/male2.mp4";
import MaleIcon3 from "../assets/images/digitalemployee/male3.mp4";
import MaleIcon4 from "../assets/images/digitalemployee/male4.mp4";
import MaleIcon5 from "../assets/images/digitalemployee/male5.mp4";
import MaleIcon6 from "../assets/images/digitalemployee/male6.mp4";
import MaleIcon7 from "../assets/images/digitalemployee/male7.mp4";
import MaleIcon8 from "../assets/images/digitalemployee/male8.mp4";
import MaleIcon9 from "../assets/images/digitalemployee/male9.mp4";

import FemaleIcon1 from "../assets/images/digitalemployee/female1.mp4";
import FemaleIcon2 from "../assets/images/digitalemployee/female2.mp4";
import FemaleIcon3 from "../assets/images/digitalemployee/female3.mp4";
import FemaleIcon4 from "../assets/images/digitalemployee/female4.mp4";
import FemaleIcon5 from "../assets/images/digitalemployee/female5.mp4";
import FemaleIcon6 from "../assets/images/digitalemployee/female6.mp4";

import DummyIcon from "../assets/images/digitalemployee/default.mp4";
import GCPIcon from "../assets/images/gcp.svg";
import { toastNotify } from "../Container/toastServices";
import { APP_CONST } from "../Constants/app.constant";
import { DOCUMENTATION } from "../Services/APIConstants/api.constant";

export function noop() {
  // intentionally does nothing
}

export const isAdmin = () => {
  return (
    localStorageGetItem(APP_CONST.KEYCLOAK_STORAGE_KEYS.IS_ADMIN) === "true"
  );
};

export const logGAPageView = (page, title) => {
  if (globalThis?.IS_GA_ENABLED === "TRUE") {
    ReactGA.send({
      hitType: "pageview",
      page: page,
      title: title,
    });
  }
};

export const removeEmptyElements = (array = []) => {
  return array.filter((item) => item !== "");
};


export const splitTextByNewLines = (text) => {
  const splitText = (text || "").split("\n");
  const filteredSentences = splitText.filter(
    (sentence) => sentence.trim() !== "",
  );
  return filteredSentences.map((item) => item.trim()) || [];
};

export const splitByNewLines = (text) => {
  if (Array.isArray(text)) {
    return text
      .map((item) => (typeof item === "object" ? item?.title : item))
      .map((value) => value?.trim())
      .filter(Boolean);
  }

  return String(text)
    .split("\n")
    .map((item) => item.replace(/^[.\-•]\s*/, "").trim())
    .filter(Boolean);
};

export const renderResultsCount = (
  resultCount = 0,
  totalCount = 0,
  keyword = "",
) => {
  const resultLabel = resultCount === 1 ? "result" : "results";

  const getLabel = (count, term) => {
    if (count === 1) {
      return term;
    }
    if (term === "process") {
      return term + "es";
    }
    return term + "s";
  };

  const label = getLabel(totalCount, keyword);
  return (
    <div
      className={`${keyword}sCount d-flex justify-content-start align-items-center`}
    >
      {APP_CONST.SHOWING}
      <span className="px-1">
        {resultCount} {resultLabel}
      </span>
      {APP_CONST.OUT_OF} {totalCount} {label}
    </div>
  );
};

export const getProviderIcon = (provider) => {
  switch (provider?.toLowerCase()) {
    case "aws":
      return AWSIcon;
    case "azure":
      return AzureIcon;
    case "nvidia":
      return NvidiaIcon;
    case "gcp":
      return GCPIcon;
    default:
      return null;
  }
};

export const removeStorage = () => {
  localStorageRemoveItem(APP_CONST.KEYCLOAK_STORAGE_KEYS.EXP);
  localStorageRemoveItem(APP_CONST.KEYCLOAK_STORAGE_KEYS.IAT);
  localStorageRemoveItem(APP_CONST.KEYCLOAK_STORAGE_KEYS.REFRESH_TOKEN);
  localStorageRemoveItem(APP_CONST.KEYCLOAK_STORAGE_KEYS.ACCESS_TOKEN);
  localStorageRemoveItem(APP_CONST.KEYCLOAK_STORAGE_KEYS.AUTH_SERVER_ID);
  localStorageRemoveItem(APP_CONST.KEYCLOAK_STORAGE_KEYS.EMAIL_ID);
  return true;
};

export const boldLastWord = (text) => {
  const words = text.trim().split(" ");
  if (words.length === 0) return null;
  const lastWord = words.pop();
  const rest = words.join(" ");
  return (
    <span>
      {rest} <b>{lastWord}</b>
    </span>
  );
};

export const formatTime = (timeInput) => {
  let minute = Math.floor(timeInput / 60);
  minute = minute < 10 ? "0" + minute : minute;
  let second = Math.floor(timeInput % 60);
  second = second < 10 ? "0" + second : second;
  return `${minute}:${second}`;
};

export const formatDate = (param) => {
  const day = new Date(param).getDate();
  const month = new Date(param).toLocaleString("en-US", { month: "short" });

  // Get ordinal suffix
  const date = day < 10 ? "0" + day : day;

  const getSuffix = (dayNum) => {
    if (dayNum % 10 === 1 && dayNum !== 11) {
      return "st";
    }
    if (dayNum % 10 === 2 && dayNum !== 12) {
      return "nd";
    }
    if (dayNum % 10 === 3 && dayNum !== 13) {
      return "rd";
    }
    return "th";
  };

  const suffix = getSuffix(day);

  return `${date}${suffix} ${month}`;
};

export const getUnitById = (unitValue) => {
  return JSON.parse(localStorageGetItem(APP_CONST.UNITS_DATA)).find(
    (unit) => unit.value === unitValue,
  );
};

export const copyToClipboard = (data) => {
  const textToCopy =
    typeof data === "string" ? data : JSON.stringify(data, null, 2);
  navigator.clipboard
    .writeText(textToCopy)
    .then(() => toastNotify(APP_CONST.COPIED_TO_CLIPBOARD, "success"))
    .catch((err) => {
      console.error("Failed to copy text: ", err);
      toastNotify(APP_CONST.SOMETHING_WENT_WRONG_WITH_COPY, "error");
    });
};

export const getIcon = (ProfilePicName) => {
  // if ProfilePicName having .png or .jpg then remove the extension
  if (ProfilePicName?.includes(".png") || ProfilePicName?.includes(".jpg")) {
    ProfilePicName = ProfilePicName.split(".")[0];
  }
  switch (ProfilePicName) {
    case "male1":
      return MaleIcon1;
    case "male2":
      return MaleIcon2;
    case "male3":
      return MaleIcon3;
    case "male4":
      return MaleIcon4;
    case "male5":
      return MaleIcon5;
    case "male6":
      return MaleIcon6;
    case "male7":
      return MaleIcon7;
    case "male8":
      return MaleIcon8;
    case "male9":
      return MaleIcon9;
    case "female1":
      return FemaleIcon1;
    case "female2":
      return FemaleIcon2;
    case "female3":
      return FemaleIcon3;
    case "female4":
      return FemaleIcon4;
    case "female5":
      return FemaleIcon5;
    case "female6":
      return FemaleIcon6;
    default:
      return DummyIcon;
  }
};

export const isValidObject = (obj) => {
  return obj && Object.keys(obj).length > 0;
};

export const isValidArray = (arr) => {
  return Array.isArray(arr) && arr.length > 0;
};

export const getUserPersonna = () => {
  return (
    localStorageGetItem(APP_CONST.KEYCLOAK_STORAGE_KEYS.USER_PERSONA) ||
    "Creator"
  );
};

export const isValidString = (value) =>
  value !== undefined && value !== null && value !== "";

// Keyboard event handler for Enter key
export const handleKeyboardEvent = (event, callback) => {
  if (event.key === "Enter") {
    event.preventDefault();
    callback();
  }
};

export const openDocumentation = () => {
  globalThis?.open(`${globalThis?.API_BASE_URL}${DOCUMENTATION}`, "_blank");
};

export const handleApiError = (
  error,
  defaultMessage = APP_CONST.ERROR_PROCESSING_REQUEST,
) => {
  const status = error?.status;
  if (status === 500 || status === 401 || status === 403) {
    return;
  }
  const errorMessage =
    error?.data?.error || error?.data?.detail || defaultMessage;
  toastNotify(errorMessage, APP_CONST.ERROR);
};

// Safe property accessor — prevents Object Injection Sink vulnerabilities
// when using dynamic keys (bracket notation) to read object properties.
export const getOwnPropertyValue = (obj, key) =>
  Object.hasOwn(obj, key)
    ? Object.getOwnPropertyDescriptor(obj, key)?.value
    : undefined;

// Safe property writer for dynamic keys without bracket notation.
export const defineOwnProperty = (obj, key, value) => {
  Object.defineProperty(obj, key, {
    value,
    enumerable: true,
    configurable: true,
    writable: true,
  });
};
